export default "__VITE_PUBLIC_ASSET__91a24264__"